import HomeCard from "../../../UI/HomeCard";
import { BsPencilSquare } from "react-icons/bs";

const Frontend = () => {
  return (
    <HomeCard>
      <h2>
        <BsPencilSquare /> FRONTEND WEB DEVELOPMENT
      </h2>

      <p>
        I specialize in building modern, responsive, and high-performance user
        interfaces using React and Next.js.
      </p>

      <div>
        <p>My frontend experience and skills include:</p>
        <ul>
          <li>
            Developing scalable UI components using JavaScript (ES6+) and React
          </li>
          <li>
            Building SEO-friendly and performant applications with Next.js
          </li>
          <li>
            Managing application state and optimizing rendering performance
          </li>
          <li>Integrating REST APIs and handling dynamic data</li>
          <li>
            Experience with modern UI libraries and component systems such as
            Material UI, shadcn/ui, and other contemporary frontend tools.
          </li>

          <li>Implementing responsive designs and improving user experience</li>
        </ul>
      </div>
    </HomeCard>
  );
};

export default Frontend;
